import loginConfig from "./login/ge";
import usersConfig from "./users/ge";
import sidebarConfig from "./sidebar/ge";
import topbarConfig from "./topbar/ge";
import sliderConfig from "./slider/ge";
import toastMessages from "./toastMessages/ge";
const translations = {
  "common.English": "ინგლისური",
  "common.English.short": "ინგ",
  "common.Georgian": "ქართული",
  "common.Georgian.short": "ქარ",
  "common.Hello": "გამარჯობა",
  "common.Operation.Successfully": "ოპერაცია დამთავრდა წარმატებით",
  "common.Sure": "დარწმუნებული ხართ?",
  "common.Male": "მამრობითი",
  "common.Female": "მდედრობითი",
  "common.IsActive": "აქტიური",
  "common.PageNotFound": "გვერდი ვერ მოიძებნა",
  "common.PageLoadFailed": "გვერდის ჩატვირთა ვერ მოხერხდა",
  "common.PageCrashed": "გვერდი მწყობრიდან გამოვიდა",
  "common.NoRowsToShow": "ცხრილი ცარიელია",

  ...loginConfig,
  ...usersConfig,
  ...sidebarConfig,
  ...topbarConfig,
  ...sliderConfig,
  ...toastMessages,
};

export default translations;
